
import { Helmet } from 'react-helmet';

import styles from './Verification.module.css';
import HeroSection from '../../../components/Verification/HeroSection/HeroSection';
import Benefits from '../../../components/Verification/Benefits/Benefits';
import Plans from '../../../components/Verification/PricingPlan/PricingPlan';
import MoneyBack from '../../../components/Verification/MoneyBack/MoneyBack'; 
function Verification() { 
    return (
        <div className={styles.wrapper}>
            <Helmet>
                <title>FindCV - Verification</title>
            </Helmet>
            <div className={styles.container}>
                <div className={styles.HeroSectionWrapper}>
                    <HeroSection />

                </div>
                <Benefits /> 
                <Plans />
                <MoneyBack />
 

            </div>
        </div>
    );
}

export default Verification;